var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 50,
    height: 50,
    viewBox: "0 0 17.19 17.353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#05a4f9",
    d: "M13.254 12.704c5.311-6.138-1.988-15.707-9.26-11.79-6.018 3.24-5.006 12.18 1.499 14.108 1.593.472 3.403.293 4.939-.295.521-.2 1.604-1.198 2.117-1.093.34.07.649.513.881.746l2.117 2.117c.3.3.742.932 1.233.848.818-.14.208-.99-.087-1.29-1.084-1.104-2.174-2.46-3.439-3.35M7.08 1.175c4.582-.542 7.968 4.366 6.637 8.53-.832 2.603-3.123 4.16-5.755 4.472-4.582.543-7.968-4.365-6.637-8.53.833-2.603 3.124-4.16 5.755-4.472z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchRight);
export default __webpack_public_path__ + "static/media/search-right.059a21a6af7b38c3f6aef63c77fc9123.svg";
export { ForwardRef as ReactComponent };